import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"transform":"scale(.3)","transform-origin":"center","width":"48px","height":"48px"} }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      fill: "none",
      viewBox: "0 0 24 24"
    }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M21.229 6.604a1 1 0 0 1 0 1.414L10.256 18.99a1 1 0 0 1-1.408.006l-6.185-6.075a1 1 0 0 1-.013-1.414l.7-.714a1 1 0 0 1 1.415-.013l4.771 4.687 9.571-9.572a1 1 0 0 1 1.415 0z",
        "clip-rule": "evenodd",
        style: {"fill":"#fff"}
      })
    ], -1)
  ]))]))
}
export default { render: render }